<script>
    export let items
    export let columns
</script>

<style>
    section {
        --columns: 3;
        display: grid;
        grid-gap: 1rem;
        grid-template-columns: repeat(var(--columns), 1fr);
    }

    article {
        --background: var(--orange);
        height: 7.5vw;
        border-radius: 2px;
        background-color: var(--background);
        box-shadow: 1px 2px 5px rgba(0, 0, 0, 0.0125), 1px 5px 10px rgba(0, 0, 0, 0.05);
    }
</style>

<section style="--columns: {columns}">
    {#each new Array(Number(items)) as item}
        <article />
    {/each}
</section>
